<template>
  <div id="app">
    <way-header v-if="$route.name !== 'teachers'"></way-header>
    <router-view/>
    <auditions @setDiaLog="setDiaLog" :mobile="auditionsMobile" v-show="auditionsShow"/>
    <way-footer v-if="$route.name !== 'teachers'"></way-footer>
    <div v-if="$route.meta.fix" class="row justify-content-between align-items-end fix" :class="{'show': !navBarFixed}">
      <div class="col-xl-10 col-md-10 xol-12 content">
        <div class="logo"></div>
        <p class="tit">
          免费领取价值<span>300元</span>试听课
        </p>
        <div class="input">
          <input type="text" v-model="auditionsMobile" placeholder="请输入手机号">
          <div class="btn" @click="auditionsBtn">免费领取</div>
        </div>
      </div>
    </div>
    <div class="alert alert-warning" role="alert" v-show="alertShow">
      <strong>请输入正确的手机号!</strong>
    </div>
  </div>
</template>

<script>
import wayHeader from './components/wayHeader.vue';
import wayFooter from './components/wayFooter.vue';
import auditions from './components/auditions.vue';

export default {
  name: 'App',
  components: {
    wayHeader,
    wayFooter,
    auditions,
  },
  data() {
    return {
      navBarFixed: false,
      auditionsShow: false,
      alertShow: false,
      auditionsMobile: '',
    };
  },
  mounted() {
    window.addEventListener('scroll', this.watchScroll);
  },
  methods: {
    watchScroll() {
      // console.log(window.scrollY)
      const scrollTop = window.scrollY;
      //  当滚动超过 50 时，实现吸顶效果
      if (scrollTop > 100) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    auditionsBtn() {
      const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (!reg.test(this.auditionsMobile)) {
        const _this = this;
        this.alertShow = true;
        setTimeout(() => {
          _this.alertShow = false;
        }, 2000);
        return;
      }
      this.auditionsShow = true;
    },
    setDiaLog() {
      this.auditionsMobile = '';
      this.auditionsShow = false;
    },
  },
};
</script>

<style lang="less">
@import './assets/css/reset.less';
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  .show {
    display: none !important;
  }
  .fix {
    display: block;
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 33;
    height: 60px;
    background: rgba(0,0,0,0.5);
    .content {
      position: relative;
      max-width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      padding-left: 200px;
      .logo {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 160px;
        height: 160px;
        background: url(./assets/img/logo1.png) no-repeat center;
        background-size: cover;
      }
      .tit {
        width: 370px;
        font-size: 24px;
        margin: 0 0 5%;
        line-height: 60px;
        color: #fff;
        span {
          color: #FE9D15;
        }
      }
      .input {
        width: 300px;
        height: 40px;
        margin-top: 10px;
        display: flex;
        input {
          height: 100%;
          border-radius: 8px 0 0 8px;
          outline: none;
          border: none;
          padding: 5px 10px;
          font-size: 12px;
        }
        .btn {
          width: 80px;
          color: #fff;
          height: 40px;
          line-height: 40px;
          padding: 0;
          font-size: 14px;
          border-radius: 0 8px 8px 0;
          border: none;
          background: linear-gradient(90deg, #FFB83F, #FE9000);
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  #app {
    .fix {
      .content {
        width: 80%;
      }
    }
  }
}
@media screen and (max-width: 900px) {
  #app {
    .fix {
      .content {
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 414px) {
  #app {
    .show {
      display: block !important;
    }
    .fix {
      padding: 0 10px;
      .content {
        width: 100%;
        padding-left: 0;
        justify-content: center;
        .logo {
          display: none;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 80px;
          height: 80px;
          background: url(./assets/img/logo1.png) no-repeat center;
          background-size: cover;
        }
        .tit{
          font-size: 12px;
          width: 150px;
        }
        .input {
          width: 160px;
          height: 30px;
          margin-top: 15px;
          display: flex;
          input {
            width: 100px;
          }
          .btn {
            width: 60px;
            color: #fff;
            height: 30px;
            line-height: 30px;
            padding: 0;
            font-size: 12px;
            border-radius: 0 8px 8px 0;
            border: none;
            background: linear-gradient(90deg, #FFB83F, #FE9000);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue